// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { Feedback, FeedbackSummary } from '../models';

export const useFeedbackService = () => {
    // properties
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const addFeedback = async (feedback: Feedback): Promise<any> => {
        const res = await axios.post(`${apiUrl}/feedback`, feedback);
        return res.data;
    };

    const getAllFeedbackSummary = async (): Promise<FeedbackSummary[]> => {
        const res = await axios.get(`${apiUrl}/feedback/summary`);
        return res.data;
    };

    return {
        addFeedback,
        getAllFeedbackSummary,
    };
};
